import type { SVGProps } from "react";
const SenecPictogramMoreCorporateStructure = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 6H28V11H37V21.7789C40.0102 23.7416 42 27.1384 42 31C42 37.0751 37.0751 42 31 42C25.6079 42 21.1219 38.1202 20.1814 33H18V39H6V35C6 34.4477 6.44772 34 7 34C7.55228 34 8 34.4477 8 35V37H16V17H8V30C8 30.5523 7.55228 31 7 31C6.44772 31 6 30.5523 6 30V15H10V6ZM18 31H20C20 26.7253 22.4383 23.0201 26 21.1994V8H12V15H18V31ZM35 13V20.7499C33.7603 20.2657 32.4112 20 31 20C29.96 20 28.9537 20.1443 28 20.4141V13H35ZM22 31C22 26.0294 26.0294 22 31 22C35.9706 22 40 26.0294 40 31C40 35.9706 35.9706 40 31 40C26.0294 40 22 35.9706 22 31ZM35 27H28V29H31.5858L26.7929 33.7929L28.2071 35.2071L33 30.4142V34H35V27Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramMoreCorporateStructure;
